/**
 * The full-page move the customer session makes when it ends: the API client's
 * forced sign-out and the auth store's logout. A full load rather than a
 * router push, so nothing of the old session survives in memory.
 *
 * Its own module so a spec can replace it: jsdom implements no navigation, and
 * makes `window.location` and its `href` non-configurable, so without this seam
 * a test can only check the address was COMPUTED, never that the browser was
 * sent there. (The super-admin console has the same seam: lib/admin/session/leave.ts.)
 */
export function hardNavigate(href: string): void {
  window.location.href = href
}
